// sleep code
var sleepInCartTray = (delay) =>
new Promise((resolve) => setTimeout(resolve, delay));

// Labor Day promo gifts (Checkout Wizard / Kite auto-add). Used to lock
// quantity steppers on those lines even if the discount allocation hasn't
// landed on the JSON yet.
window.ANCESTRAL_PROMO_GIFT_VARIANT_IDS = {
  43096240160905: "digestive-enzymes",
  45245746937993: "tallow-balm",
};

// Styles for promo-managed (discounted) lines: quantity controls disabled,
// remove link stays usable.
(function ancestralPromoLineStyles() {
  if (document.getElementById("ancestral-promo-line-style")) return;
  const style = document.createElement("style");
  style.id = "ancestral-promo-line-style";
  style.textContent =
    "#slidecarthq .item[data-promo-line] .quantity-selector{pointer-events:none;opacity:.45;}" +
    "#slidecarthq .item[data-promo-line] .main-medium{pointer-events:none;opacity:.6;}";
  document.head.appendChild(style);
})();

// Poll for a condition instead of a fixed sleep — resolves as soon as the
// condition is true, so drawer decoration lands faster after each re-render
// (smaller widget pop-in window), while still tolerating slow loads.
async function waitForCartTrayCondition(fn, timeout, interval) {
  timeout = timeout || 1500;
  interval = interval || 120;
  const start = Date.now();
  while (Date.now() - start < timeout) {
    try {
      if (fn()) return true;
    } catch (err) {}
    await sleepInCartTray(interval);
  }
  return false;
}

function handOptionAllProductSildeCartAR(){
  const checCartOption = document.querySelector("#slidecarthq");
  if (!checCartOption) return;
  const checkProductOption = document.querySelector("#slidecarthq .slidecarthq .items .item[data-option-status='subcription']");
  const checkSlidecarthq = document.querySelector("#slidecarthq.option__subsave");
  const checkSlidecarthqSub = document.querySelector("#slidecarthq .rewards-progress");
  const checkUpsellTitleCR = document.querySelector("#slidecarthq .custom-money_shipping .title_upsell h2");
  const checkShippingCR = document.querySelector("#slidecarthq .footer .rewards-shipping-text");
  const checkTitleShipping = document.querySelector("#slidecarthq .rewards .rewards-unlock-text p");
  const itemSlideCarts = document.querySelectorAll("#slidecarthq .items");
  if (itemSlideCarts.length) {
   itemSlideCarts.forEach((e, i) => {
     const optionSubcrition = e.querySelector(".item[data-selling-plan='4315775113']");
     const optionSubcrition_2 = e.querySelector(".item[data-selling-plan='4315807881']");

     // Prepaid product 1
     
    if (optionSubcrition) {
      const optionSubcrition_add = e.querySelector(".item[data-selling-plan='4315775113'] .main-medium");
      const optionSubcrition_discount = e.querySelector(".item[data-selling-plan='4315775113'] .main-bottom .price");
      const optionSubcrition_comparePrice = e.querySelector(".item[data-selling-plan='4315775113'] .main-bottom");
      const optionSubcrition_paln = e.querySelector(".item[data-selling-plan='4315775113'] .variants-p");
      const optionSubcrition_paln_val = optionSubcrition_paln.innerHTML;
      const originalString = optionSubcrition_paln_val;
      const stringToRemove = "1 Month,";
      const optionSubcrition_discount_val = optionSubcrition_discount.innerHTML;
      const stToRemove = "$";
      const remove_val = optionSubcrition_discount_val.replace(stToRemove, "");
      const discountedPrice = parseFloat(remove_val);


    // Use the replace function to remove the specified string
      
    var modifiedString = originalString.replace(stringToRemove, "");
      //console.log(modifiedString);
      
        const newDiv = document.createElement("div");
        const Strick_price = document.createElement("span");
        const installemnts = document.createElement("div");
        installemnts.className = 'insatll-month prpaid-class';
       newDiv.className = 'row-ten message-discount';
       Strick_price.className = 'price strike-through custom-strick';
      if(modifiedString == "   3 Months") {
      newDiv.innerHTML = `Subscribe & Save 15% Off!`;
      const discountPercentage = 15;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Quarterly (Every 3 Months)`;
       } 
     if (modifiedString == "   6 Months") {
      newDiv.innerHTML = `Subscribe & Save 20% Off!`;
      const discountPercentage = 20;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Semi-Annually (Every 6 Months)`;
       }
      if (modifiedString == "   12 Months") {
       newDiv.innerHTML = `Subscribe & Save 25% Off!`;
       const discountPercentage = 25;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Annually (Every 12 Months)`;
      }
      
      optionSubcrition_comparePrice.appendChild(Strick_price);

       optionSubcrition_discount.appendChild(newDiv);
        optionSubcrition.classList.add('option__prepaid');
       optionSubcrition_add.innerHTML = `<div class="prpaid-class">One Bottle Delivered Monthly for ${modifiedString}</div>`;
       optionSubcrition_add.appendChild(installemnts);
     }

    // Prepaid product 2

     if (optionSubcrition_2) {
      const optionSubcrition_add = e.querySelector(".item[data-selling-plan='4315807881'] .main-medium");
      const optionSubcrition_discount = e.querySelector(".item[data-selling-plan='4315807881'] .main-bottom .price");
      const optionSubcrition_comparePrice = e.querySelector(".item[data-selling-plan='4315807881'] .main-bottom");
      const optionSubcrition_paln = e.querySelector(".item[data-selling-plan='4315807881'] .variants-p");
      const optionSubcrition_paln_val = optionSubcrition_paln.innerHTML;
      const originalString = optionSubcrition_paln_val;
      const stringToRemove = "1 Month,";
      const optionSubcrition_discount_val = optionSubcrition_discount.innerHTML;
      const stToRemove = "$";
      const remove_val = optionSubcrition_discount_val.replace(stToRemove, "");
      const discountedPrice = parseFloat(remove_val);


    // Use the replace function to remove the specified string
      
    var modifiedString = originalString.replace(stringToRemove, "");
      //console.log(modifiedString);
      
        const newDiv = document.createElement("div");
        const Strick_price = document.createElement("span");
        const installemnts = document.createElement("div");
        installemnts.className = 'insatll-month prpaid-class';
       newDiv.className = 'row-ten message-discount';
       Strick_price.className = 'price strike-through custom-strick';
      if(modifiedString == "   3 Months") {
      newDiv.innerHTML = `Subscribe & Save 15% Off!`;
      const discountPercentage = 15;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Quarterly (Every 3 Months)`;
       } 
     if (modifiedString == "   6 Months") {
      newDiv.innerHTML = `Subscribe & Save 20% Off!`;
      const discountPercentage = 20;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Semi-Annually (Every 6 Months)`;
       }
      if (modifiedString == "   12 Months") {
       newDiv.innerHTML = `Subscribe & Save 25% Off!`;
       const discountPercentage = 25;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Annually (Every 12 Months)`;
      }
      
      optionSubcrition_comparePrice.appendChild(Strick_price);

       optionSubcrition_discount.appendChild(newDiv);
        optionSubcrition_2.classList.add('option__prepaid');
       optionSubcrition_add.innerHTML = `<div class="prpaid-class">One Bottle Delivered Monthly for ${modifiedString}</div>`;
       optionSubcrition_add.appendChild(installemnts);
     }
     
     });
    }
  if(checkProductOption){
    checCartOption.classList.remove('option__onetime');
    checCartOption.classList.add('option__subsave');
    if (checkTitleShipping) {
      checkTitleShipping.innerText = "Your order qualifies for FREE SHIPPING (U.S. Only)!";
    }
    if(checkShippingCR){
      checkShippingCR.innerText = "Taxes Calculated at Checkout.";
    }
    if(checkSlidecarthqSub){
      checkSlidecarthqSub.style.minWidth = "100%";
    }
    if(checkUpsellTitleCR){
      checkUpsellTitleCR.innerText = "You may also like…";
    }
  } else {
    checCartOption.classList.remove('option__subsave');
    checCartOption.classList.add('option__onetime');
    if(checkUpsellTitleCR){
      checkUpsellTitleCR.innerText = "Add product to get FREE SHIPPING";
    }
    if(checkShippingCR){
      checkShippingCR.innerText = "Taxes And Shipping Calculated At Checkout.";
    }
    if(checkSlidecarthqSub){
      checkSlidecarthqSub.style.minWidth = "0%";
    }
    const slideMoney = 120;
    const cehckSlideMoneyTotal = document.querySelector(".slidecart-subtotal");
    if(cehckSlideMoneyTotal){
      const slideMoneyTotal = cehckSlideMoneyTotal.textContent;
      const currencySymbol = "$"; 
      const slideMoneyTotalChange = parseFloat(slideMoneyTotal.replace(currencySymbol, ''));
      if (slideMoneyTotalChange <= slideMoney ){
          const mathslideMoneyTotalChange = slideMoney - slideMoneyTotalChange ;
          if(checkTitleShipping){
            checkTitleShipping.innerText = `Free Shipping (U.S. Only) only $${parseFloat(mathslideMoneyTotalChange).toFixed(2)} Away!`;
          }
          if(checkUpsellTitleCR) checkUpsellTitleCR.innerText = "Add product to get FREE SHIPPING";
          if(checkShippingCR) checkShippingCR.innerText = "Taxes And Shipping Calculated At Checkout.";
          if(checkSlidecarthqSub) checkSlidecarthqSub.style.minWidth = "0%";
      } else {
        if(checkTitleShipping) checkTitleShipping.innerText = "Your order qualifies for FREE SHIPPING (U.S. Only)!";
        if(checkUpsellTitleCR) checkUpsellTitleCR.innerText = "You may also like…";
        if(checkShippingCR) checkShippingCR.innerText = "Taxes Calculated at Checkout.";
        if(checkSlidecarthqSub) checkSlidecarthqSub.style.minWidth = "100%";
      }
    }
  }
}
function handCheckOptionAllProductSildeCart(){
    const itemSlideCarts = document.querySelectorAll("#slidecarthq .items .item");
    if (itemSlideCarts.length) {
      itemSlideCarts.forEach((e, i) => {
        const optionSubcrition = e.querySelector(".rc_widget__option--subsave");
        const optionOnetime = e.querySelector(".rc_widget__option--onetime");
        const cartOptionForm = document.querySelector("#slidecarthq");
        function handleOptionOneTime() {
          if(cartOptionForm.classList.contains('option__subsave')){
            cartOptionForm.classList.remove('option__subsave');
          }
          cartOptionForm.classList.add('option__onetime');
        }
        function handleOptionSub() {
          if(cartOptionForm.classList.contains('option__onetime')){
            cartOptionForm.classList.remove('option__onetime');
          }
          cartOptionForm.classList.add('option__subsave');
        }
        if (optionSubcrition) {
          optionSubcrition.addEventListener("click", handleOptionSub);
        }
        if (optionOnetime) {
          optionOnetime.addEventListener("click", handleOptionOneTime);
        }
      });
    }
}

function handlePriceWhenChangeOptionSkio(selectItem, selectPrice) {
  const itemsCardProduct = document.querySelectorAll(selectItem);
  if (itemsCardProduct.length) {
    itemsCardProduct.forEach((e, i) => {
      const optionSubcrition = e.querySelector("[data-radio-subsave]");
      const optionOnetime = e.querySelector("[data-radio-onetime]");

      if (optionSubcrition && optionOnetime) {
        optionSubcrition.onchange = function () {
          let price = this.form;
          let percent = 10;

          if (price.getAttribute("subcription") == "5%") {
            percent = 5;
          }

          price = price.querySelectorAll(selectPrice);

          price.forEach((e) => {
            let valuePrice = e.innerText;
            valuePrice = valuePrice.substring(1);
            let discount = (Number(valuePrice) / 100) * percent;
            let priceDiscount = Number(valuePrice) - discount;
            priceDiscount = priceDiscount.toFixed(2);
            let oneTimeValue = e.getAttribute('data-one-time');
            if(oneTimeValue == "$74.95"){
              e.innerText = `$67.46`;
             }
            else{
              e.innerText = `$${priceDiscount}`;
            }
            
            e.style.color = "#bd472a";
          });
        };

        optionOnetime.onchange = function () {
          let price = this.form;
          let percent = 10;

          if (price.getAttribute("subcription") == "5%") {
            percent = 5;
          }

          price = price.querySelectorAll(selectPrice);

          price.forEach((e) => {
            let valuePrice = e.innerText;
            let oneTimeValue = e.getAttribute('data-one-time');
            //alert(oneTimeValue);
            valuePrice = Number(valuePrice.substring(1));
            let discount = valuePrice / (100 - percent);
            discount = discount * percent;
            let priceDiscount = valuePrice + discount;
            priceDiscount = priceDiscount.toFixed(2);
            e.innerText = `${oneTimeValue}`;
            e.style.color = "#1f0a00";
          });
        };
      }
    });
  }
}

// Serialization: only ONE decoration pass may run at a time. Overlapping
// passes wipe/rebuild the same row DOM concurrently, which reads as the
// whole drawer "vibrating" (worst on subscription rows — biggest widgets).
var ancestralCartTrayPassRunning = false;
var ancestralCartTrayPassQueued = false;

async function ancestralApplyWidgetRechargeCartTray(cart) {
  if (ancestralCartTrayPassRunning) {
    ancestralCartTrayPassQueued = true;
    return;
  }
  ancestralCartTrayPassRunning = true;
  try {
    await ancestralApplyWidgetRechargeCartTrayInner(cart);
  } finally {
    ancestralCartTrayPassRunning = false;
    if (ancestralCartTrayPassQueued) {
      ancestralCartTrayPassQueued = false;
      // Re-run once with the latest cart so the final state is decorated.
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (latest) {
          ancestralCartTrayLastSig = ancestralCartTraySignature(latest);
          return ancestralApplyWidgetRechargeCartTray(latest);
        })
        .catch(function () {});
    }
  }
}

async function ancestralApplyWidgetRechargeCartTrayInner(cart) {
  loadingCart();
  try {
  // Wait for the drawer to have rendered one row per cart line (max 1.5s)
  await waitForCartTrayCondition(function () {
    return (
      document.querySelectorAll("#slidecarthq .slidecarthq .items .item")
        .length >= cart.items.length
    );
  });
  addNodeParentRC(cart.items);

  let items = document.querySelectorAll(
    "#slidecarthq .slidecarthq .items .item"
  );
  
  items = Array.prototype.slice.call(items);

  items.forEach((e) => e.classList.remove("loaded"));

  const config = items.map((e) => {
    return {
      productId: Number(e.dataset.productid),
      injectionParent: `.rc-widget-injection-parent-cart-tray-${e.dataset.productid}-${e.dataset.sellingPlan}`,
      injectionMethod: "prepend",
      selectors: {
        price: [".none"],
        variant: [".none"],
      },
    };
  });

  const addTextMostPopular = () => {
    let optionFirst = document.querySelectorAll(
      "#slidecarthq select.rc-selling-plans__dropdown option:first-child"
    );

    optionFirst.forEach((e) => {
      let text = e.innerText;
      let hasAdd = text.includes("Most popular") ? true : false;
      if (hasAdd === true) return;
      text = `${text} (Most popular)`;
      e.innerText = text;
    });
  };

  addOtpIn();

  // DISABLED 2026-08-10: subscriptions run on Skio; the legacy ReCharge
  // widget re-initializing inside drawer rows caused constant re-renders
  // ("vibrating" sub rows) and spurious change events that fired the
  // remove+re-add toggle path (phantom extra units). Re-enable only if the
  // store moves back to ReCharge.
  var ANCESTRAL_ENABLE_RC_CART_WIDGET = false;
  if (
    ANCESTRAL_ENABLE_RC_CART_WIDGET &&
    window.ReChargeWidget &&
    typeof window.ReChargeWidget.createWidgets === "function"
  ) {
    window.ReChargeWidget.createWidgets(config);
  }

  // Wait for the subscription widgets to inject (max 1.5s) instead of a
  // fixed 1s sleep, so rows finish rendering as early as possible.
  if (ANCESTRAL_ENABLE_RC_CART_WIDGET) {
    await waitForCartTrayCondition(function () {
      return document.querySelector(
        "#slidecarthq .items .item input.rc-radio__input"
      );
    });
  }
  addTextMostPopular();
  addPrefixForInputAndLabelCartTray();
  handleSelectorOptionRCinCartTray();
  if (ANCESTRAL_ENABLE_RC_CART_WIDGET) {
    await waitForCartTrayCondition(function () {
      return document.querySelector(
        "#slidecarthq .items .item .rc_popup__how_it_works p"
      );
    }, 1200);
  }
  replaceRecentCorrectInTooltip(".item[data-persent]", "data-persent");
  } finally {
    removeLoadingCartTray();
  }
}

function removeLoadingCartTray() {
  const sliderCartLoad = document.querySelector("#slidecarthq");
  if (sliderCartLoad) {
    sliderCartLoad.classList.remove("active");
  }
}

function addPrefixForInputAndLabelCartTray() {
  const itemCart = document.querySelectorAll(
    "#slidecarthq .slidecarthq .items .item"
  );
  itemCart.forEach((e) => {
    const sellingPlan = e.dataset.sellingPlan;
    const listInputs = e.querySelectorAll("input.rc-radio__input");
    const listLabels = e.querySelectorAll("label.rc-radio__label");
    if (listInputs.length && listLabels.length) {
      listInputs.forEach((input) => {
        let idInput = input.getAttribute("id");
        let nameInput = input.getAttribute("name");
        idInput = `cart_tray_${idInput}_${sellingPlan}`;
        nameInput = `cart_tray_${nameInput}_${sellingPlan}`;
        input.setAttribute("id", idInput);
        input.setAttribute("name", nameInput);
      });

      listLabels.forEach((label) => {
        let forLabel = label.getAttribute("for");
        forLabel = `cart_tray_${forLabel}_${sellingPlan}`;
        label.setAttribute("for", forLabel);
      });
    }

    const dataPersent = e.dataset.persent;
    const labelSubcription = e.querySelector(
      "[data-label-subsave] [data-label-discount]"
    );

    if (dataPersent && labelSubcription) {
      labelSubcription.setAttribute("data-persent", dataPersent);
    }
  });
}

function ancestralGetDataProductCart(items) {
  const result = items.map((e) => {
    return {
      idProduct: e.product_id,
      idSellingPlan: e.selling_plan_allocation?.selling_plan.id,
      priceOrigin:
        Number(e.selling_plan_allocation?.compare_at_price) *
        Number(e.quantity),
      persent: e.properties?._subcription_percent,
      promoDiscounted:
        Number(e.line_level_total_discount || 0) > 0 ||
        !!(window.ANCESTRAL_PROMO_GIFT_VARIANT_IDS || {})[e.variant_id],
    };
  });

  return result;
}

async function addNodeParentRC(items) {
  const listItem = document.querySelectorAll(
    "#slidecarthq .slidecarthq .items .item"
  );
  const data = ancestralGetDataProductCart(items);

  listItem.forEach((item, i) => {
    // When Kite (or any app) mutates the cart mid-render, the drawer DOM and
    // cart.items can briefly disagree — skip unmatched rows instead of throwing.
    const info = data[i];
    if (!info) return;
    try {
    const classParentWidgetRC = `rc-widget-injection-parent-cart-tray-${info.idProduct}-${info.idSellingPlan}`;

    const hasMainMedium = item.querySelector(".main-medium");
    item.setAttribute("data-productid", `${info.idProduct}`);
    item.setAttribute("data-selling-plan", `${info.idSellingPlan}`);
    item.setAttribute(
      "data-option-status",
      `${info.idSellingPlan ? "subcription" : "onetime"}`
    );
    item.setAttribute(
      "data-price-origin",
      `${info.priceOrigin ? info.priceOrigin : ""}`
    );

    if (info.persent) {
      item.setAttribute("data-persent", info.persent);
    }

    // Promo-managed line (Kite BXGY discount): lock its quantity stepper —
    // incrementing it can never yield another discounted unit (the promo
    // math re-prices extras to full and moves them to the main line).
    if (info.promoDiscounted) {
      item.setAttribute("data-promo-line", "1");
    } else {
      item.removeAttribute("data-promo-line");
    }

    let nodeParentWidgetRC = document.createElement("div");
    nodeParentWidgetRC.classList.add(classParentWidgetRC);

    if (hasMainMedium) {
      hasMainMedium.innerHTML = "";
      hasMainMedium.appendChild(nodeParentWidgetRC);
    } else {
      let mainMedium = document.createElement("div");
      mainMedium.classList.add("main-medium");
      mainMedium.appendChild(nodeParentWidgetRC);
      item
        .querySelector(".main")
        .insertBefore(mainMedium, item.querySelector(".main").children[1]);
    }
    } catch (err) {
      console.error("cart tray: failed to decorate line", i + 1, err);
    }
  });
}

function handleSelectorOptionRCinCartTray() {
  const itemCart = document.querySelectorAll("#slidecarthq .item");

  itemCart.forEach((e, i) => {
    const idVariant = e.dataset.variantId,
      optionStatus = e.dataset.optionStatus,
      sellingPlanId = e.dataset.sellingPlan,
      persent = e.dataset.persent,
      priceOrigin = Number(e.dataset.priceOrigin) / 100,
      line = i + 1,
      btnOnetime = e.querySelector(
        "[data-selector-onetime] label.rc-radio__label"
      ),
      inputOnetime = e.querySelector(
        "[data-selector-onetime] input.rc-radio__input"
      ),
      btnSubcription = e.querySelector(
        "[data-selector-subsave] label.rc-radio__label"
      ),
      inputSubcription = e.querySelector(
        "[data-selector-subsave] input.rc-radio__input"
      ),
      subcriptionWrap = e.querySelector("[data-option-subsave]"),
      sellingPlan = e.querySelector("[data-option-subsave] .rc-selling-plans"),
      sellingOption = e.querySelector(
        "[data-option-subsave] select[data-plans-dropdown]"
      );

    const hasMessage = e.querySelector(".message-discount");
    const hasPriceOrigin = e.querySelector(".price.strike-through");
    const rowBottom = e.querySelector(".main-bottom");

    let mesSubcrition = document.createElement("div");
    mesSubcrition.classList.add("message-discount");
    let priceOriginNode = document.createElement("span");
    priceOriginNode.classList.add("price");
    priceOriginNode.classList.add("strike-through");
    priceOriginNode.innerText = `$${priceOrigin.toFixed(2)}`;

     /* start cart drawer percent discount daynamic changes */
  
    if(optionStatus == "subcription"){
    setTimeout(function() {
    const percentage = e.querySelector(".main-medium span.rc-option__discount.rc_widget__option__discount");
    if (!percentage) return;
    const discount_percentage = percentage.innerHTML;
       if (discount_percentage) {
      mesSubcrition.innerText = `Subscribe & Save ${discount_percentage} Off!`;
    } 
      const contentTooltip = e.querySelector(".rc_popup__how_it_works p");
    if (contentTooltip) {
     contentTooltip.innerText = `Save an additional ${discount_percentage} and FREE shipping on all US subscriptions. Change or cancel anytime.`;
    }
      }, 2000);
    }

     /* End start cart drawer percent discount daynamic changes */

    if (persent) {
      mesSubcrition.innerText = `Subscribe & Save ${persent}% Off!`;
    } else {
      mesSubcrition.innerText = "Subscribe & Save 10% Off!";
    }

    if (inputSubcription && inputOnetime) {
      if (optionStatus == "subcription") {
        inputSubcription.checked = true;
        inputOnetime.checked = false;
        sellingOption.value = sellingPlanId;
        subcriptionWrap.classList.add("rc-option--active");
        sellingPlan.style.display = "block";
        hasMessage == null && rowBottom.appendChild(mesSubcrition);
        hasPriceOrigin == null && rowBottom.prepend(priceOriginNode);
      } else if (optionStatus == "onetime") {
        inputSubcription.checked = false;
        inputOnetime.checked = true;
        subcriptionWrap.classList.remove("rc-option--active");
        sellingPlan.style.display = "none";
        hasMessage != null && hasMessage.remove();
        hasPriceOrigin != null && hasPriceOrigin.remove();
      }
    }

    e.classList.add("loaded");

    if (btnOnetime) {
      btnOnetime.onclick = function (event) {
        event.preventDefault();
        disableSelectCartTray();
        this.previousElementSibling.checked = true;
        btnSubcription.previousElementSibling.checked = false;
        subcriptionWrap.classList.remove("rc-option--active");
        sellingPlan.style.display = "none";
        const qtyCurrent = e.querySelector(
          ".quantity-selector input[type=text]"
        ).value;
        handleChangeOptionRCinCartTray(
          { id: Number(idVariant), quantity: Number(qtyCurrent) },
          line
        );
      };
    }

    if (btnSubcription) {
      btnSubcription.onclick = function (event) {
        event.preventDefault();
        disableSelectCartTray();
        const sellingOptionDefault = e
          .querySelector(
            "[data-option-subsave] select[data-plans-dropdown] option:first-child"
          )
          .getAttribute("value");
        this.previousElementSibling.checked = true;
        btnOnetime.previousElementSibling.checked = false;
        subcriptionWrap.classList.add("rc-option--active");
        sellingPlan.style.display = "block";
        const qtyCurrent = e.querySelector(
          ".quantity-selector input[type=text]"
        ).value;
        handleChangeOptionRCinCartTray(
          {
            id: Number(idVariant),
            selling_plan: Number(sellingOptionDefault),
            quantity: Number(qtyCurrent),
          },
          line
        );
      };
    }

    if (sellingOption) {
      sellingOption.onchange = function (event) {
        disableSelectCartTray();
        const qtyCurrent = e.querySelector(
          ".quantity-selector input[type=text]"
        ).value;
        handleChangeOptionRCinCartTray(
          {
            id: Number(idVariant),
            selling_plan: Number(this.value),
            quantity: Number(qtyCurrent),
          },
          line
        );
      };
    }
    
    const parentElement = document.querySelector('#slidecarthq .slidecarthq');
    if(parentElement){
      var parentHeight = parentElement.scrollHeight;
      const childCart = document.querySelector('.custom-bg-event-cartTray');
      if(childCart){
        childCart.style.height = parentHeight + 'px'; ;
      }
    }
    const sliderCartLoad = document.querySelector('#slidecarthq');
    if(sliderCartLoad){
      setTimeout(() => {
      sliderCartLoad.classList.remove('active');
      }, 500);
    }
  });
}

// Resolve a drawer row to its cart line `key` so removals target the right
// line even when another app (e.g. Kite promos) inserts lines and shifts the
// numeric indexes. Falls back to null when the line can't be identified.
async function ancestralFindLineKeyCartTray(line, variantId, sellingPlanId) {
  try {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    const cart = await res.json();
    const planOf = (it) =>
      it.selling_plan_allocation && it.selling_plan_allocation.selling_plan
        ? String(it.selling_plan_allocation.selling_plan.id)
        : "";
    const wantPlan =
      sellingPlanId && sellingPlanId !== "undefined" && sellingPlanId !== "null"
        ? String(sellingPlanId)
        : "";
    const byIndex = cart.items[line - 1];
    if (
      byIndex &&
      Number(byIndex.variant_id) === Number(variantId) &&
      planOf(byIndex) === wantPlan
    ) {
      return byIndex.key;
    }
    const exact = cart.items.filter(
      (it) =>
        Number(it.variant_id) === Number(variantId) && planOf(it) === wantPlan
    );
    if (exact.length === 1) return exact[0].key;
    const byVariant = cart.items.filter(
      (it) => Number(it.variant_id) === Number(variantId)
    );
    if (byVariant.length === 1) return byVariant[0].key;
  } catch (err) {
    console.error("cart tray: line key lookup failed", err);
  }
  return null;
}

async function removeItemCartInByKeyCartTray(lineOrKey) {
  const data =
    typeof lineOrKey === "string" ? { id: lineOrKey } : { line: lineOrKey };

  const result = await fetch("/cart/change.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      ...data,
      quantity: 0,
    }),
  });

  return result.json();
}

async function addItemCartInCartTray(data) {
  const result = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  });

  return result.json();
}

async function handleChangeOptionRCinCartTray(config, line) {
  loadingCart();
  const itemCarts = document.querySelectorAll("#slidecarthq .items .item");
  const itemEl = itemCarts[line - 1];
  const persent = itemEl ? itemEl.dataset.persent : undefined;

  handCheckOptionAllProductSildeCart();
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source");

  if (persent) {
    config = {
      ...config,
      properties: {
        subcription_percent: persent,
      },
    };
  }

  config = {
    ...config,
    properties: {
      ...config.properties,
      utm_source: utmSource,
    },
  };

  const data = {
    items: [config],
  };

  const lineKey = itemEl
    ? await ancestralFindLineKeyCartTray(
        line,
        itemEl.dataset.variantId,
        itemEl.dataset.sellingPlan
      )
    : null;
  await removeItemCartInByKeyCartTray(lineKey || line);
  await addItemCartInCartTray(data);
  // await sleepInCartTray(500);
  window.SLIDECART_UPDATE();
}

function disableSelectCartTray() {
  let labelSelects = document.querySelectorAll(
    "#slidecarthq .items .item label"
  );
  labelSelects.forEach((e) => {
    e.style.pointerEvents = "none";
  });
}

function removeDisableSelectCartTray() {
  let labelSelects = document.querySelectorAll(
    "#slidecarthq .items .item label"
  );
  labelSelects.forEach((e) => {
    e.style.pointerEvents = "";
  });
}

function replaceRecentCorrectInTooltip(
  selectItem = "form[subcription]",
  attrPecent = "subcription"
) {
  const items = document.querySelectorAll(selectItem);

  if (items.length) {
    items.forEach((e) => {
      let percent = e.getAttribute(attrPecent);
      if (!percent.includes("%")) {
        percent = `${percent}%`;
      }

      let contentTooltip = e.querySelector(".rc_popup__how_it_works p");
      if (contentTooltip) {
        contentTooltip = contentTooltip.innerText;
        contentTooltip = contentTooltip.replace("10%", percent);
        e.querySelector(".rc_popup__how_it_works p").innerText = contentTooltip;
      }
    });
  }
}

function replaceBundleProductTooltip() {
  let forms = document.querySelectorAll('form[data-productid="7224812667017"],form[data-productid="7044086464649"],form[data-productid="7271083442313"]');
  console.log(forms)
  forms.forEach((e) => {
    let contentTooltip = e.querySelector(".rc_popup__how_it_works p");
    if (contentTooltip) {
      console.log('in')
      contentTooltip.innerText = 'Save an additional 5% and FREE shipping on all US subscriptions. Change or cancel anytime.';
    }
  });
}

function addOtpIn() {
  const cartSmsParent = document.getElementById("rcsms-cart-widget-parent");
  const cartSmsChild = document.getElementById("rcsms-cart-widget");

  const cartTrayOption = document.querySelector(
    ".rc_widget__option--subsave.rc_widget__option--active"
  );
  if (cartTrayOption && cartSmsChild && cartSmsParent) {
    cartSmsParent.appendChild(cartSmsChild);
  } else if (cartSmsChild) {
    cartSmsChild.style.display = "none";
  }
}

function checkGiftCardInCart(cart) {
  const hasProductDiscount = cart.items.some((e) => e.id === 40971854610569);
  const hasGiftCard = cart.items.some((e) => e.id === 40999138689161);

  if (
    (!hasProductDiscount && !hasGiftCard) ||
    (hasProductDiscount && hasGiftCard)
  ) {
    return true;
  }

  let lineItemGiftCard;
  cart.items.forEach((e, i) => {
    if (e.id == 40999138689161) {
      lineItemGiftCard = i + 1;
    }
  });

  const addGiftCard = () => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        quantity: 1,
        id: 40999138689161,
      }),
    }).then((res) => {
      window.SLIDECART_UPDATE();
    });
  };

  const removeGiftCard = (line) => {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        line: 1,
        quantity: 0,
      }),
    }).then((res) => {
      window.SLIDECART_UPDATE();
    });
  };

  if (
    window.location.pathname.includes("/cart") ||
    window.location.pathname.includes("/products")
  ) {
    if (hasProductDiscount && !hasGiftCard) {
      window.SLIDECART_UPDATE();
      return false;
    }

    if (hasGiftCard && !hasProductDiscount) {
      window.SLIDECART_UPDATE();
      return false;
    }
  }

  if (window.location.pathname == "/collections/shop") {
    if (hasProductDiscount && !hasGiftCard) {
      addGiftCard();
    }
    if (hasGiftCard && !hasProductDiscount && lineItemGiftCard) {
      removeGiftCard(lineItemGiftCard);
    }
  }
}

const applyCountCart = (cart) => {
  const cartCount = document.getElementById("CartCount");
  if (cartCount) {
    cartCount.innerHTML = `<span>${cart.item_count}</span>`;
  }
};

if (typeof Shopify === "undefined") {
  window.Shopify = {};
}
if (typeof Shopify.getCart === "undefined") {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return jQuery.getJSON("/cart.js", function (cart, textStatus, xhr) {
        if (typeof callback === "function") {
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if (typeof callback === "function") {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === "function") {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

// Debounced update handler. Kite (discounts/free-gift) and other apps mutate
// the cart right after an add and push their own SLIDECART_SET_CART/UPDATE —
// the old close→update→reopen cycle here fought those updates and caused the
// drawer to flicker/loop. Now we coalesce rapid updates and decorate once,
// against a freshly fetched cart.
var ancestralCartTrayDebounceTimer = null;
var ancestralCartTrayLastSig = null;

// Signature of the visible cart state. Kite's allocation sync frequently
// rewrites only cart ATTRIBUTES (not lines) — when the lines are unchanged
// and the drawer rows are still decorated, we can skip the whole widget
// re-injection pass and avoid needless flicker.
function ancestralCartTraySignature(cart) {
  return (cart.items || [])
    .map(function (it) {
      return (
        it.key +
        ":" +
        it.quantity +
        ":" +
        (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan
          ? it.selling_plan_allocation.selling_plan.id
          : "")
      );
    })
    .join("|");
}

function ancestralCartTrayStillDecorated(cart) {
  const rows = document.querySelectorAll("#slidecarthq .items .item");
  if (rows.length !== (cart.items || []).length) return false;
  for (let i = 0; i < rows.length; i++) {
    if (!rows[i].dataset.productid) return false;
  }
  return true;
}

// True when the drawer's rendered rows agree with the real cart lines
// (row count and per-row quantities). During Kite's allocation churn the
// drawer can end up painted with an intermediate cart state (e.g. same-variant
// lines merged), which shows wrong quantities until the next re-render.
function ancestralCartTrayRowsMatch(cart) {
  const rows = document.querySelectorAll("#slidecarthq .items .item");
  const items = cart.items || [];
  if (rows.length !== items.length) return false;
  let rowSum = 0;
  let haveAllQtys = true;
  for (let i = 0; i < rows.length; i++) {
    const inp = rows[i].querySelector(".quantity-selector input");
    if (inp && inp.value !== "") {
      rowSum += Number(inp.value);
      if (Number(inp.value) !== items[i].quantity) return false;
    } else {
      haveAllQtys = false;
    }
  }
  // Order-proof check: displayed bottle count must equal the real cart count.
  if (haveAllQtys && rowSum !== cart.item_count) return false;
  return true;
}

// Force the drawer to re-render with the real cart. Cooldown + streak cap
// make a refresh loop impossible while still allowing retries when Kite's
// writes land after our first reconciliation.
var ancestralCartTrayLastForcedAt = 0;
var ancestralCartTrayForceStreak = 0;
function ancestralCartTrayForceRefresh(freshCart) {
  const now = Date.now();
  if (now - ancestralCartTrayLastForcedAt < 1500) return false;
  if (ancestralCartTrayForceStreak >= 3) return false;
  ancestralCartTrayLastForcedAt = now;
  ancestralCartTrayForceStreak++;
  if (typeof window.SLIDECART_SET_CART === "function") {
    window.SLIDECART_SET_CART(freshCart);
    return true;
  }
  if (typeof window.SLIDECART_UPDATE === "function") {
    window.SLIDECART_UPDATE(freshCart);
    return true;
  }
  return false;
}

// Late re-verify: Kite can write to the cart AFTER the drawer's last render
// with no further SLIDECART_UPDATED event — leaving a stale display that the
// shopper then acts on. Check once more after things settle.
var ancestralCartTraySettleTimer = null;
function ancestralCartTrayScheduleSettleCheck() {
  if (ancestralCartTraySettleTimer) clearTimeout(ancestralCartTraySettleTimer);
  ancestralCartTraySettleTimer = setTimeout(function () {
    ancestralCartTraySettleTimer = null;
    if (ancestralCartTrayPassRunning) {
      ancestralCartTrayScheduleSettleCheck();
      return;
    }
    if (!document.querySelector("#slidecarthq .items .item")) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (ancestralCartTrayRowsMatch(cart)) {
          ancestralCartTrayForceStreak = 0;
        } else {
          ancestralCartTrayForceRefresh(cart);
        }
      })
      .catch(function () {});
  }, 1800);
}

window.SLIDECART_UPDATED = function (cart) {
  if (typeof SECOMAPP === "undefined") {
    SECOMAPP = {};
  }

  SECOMAPP.preShowPopup = function () {
    window.SLIDECART_CLOSE();
  };

  if (ancestralCartTrayDebounceTimer) {
    clearTimeout(ancestralCartTrayDebounceTimer);
  }
  ancestralCartTrayDebounceTimer = setTimeout(function () {
    ancestralCartTrayDebounceTimer = null;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.json();
      })
      .catch(function () {
        return cart;
      })
      .then(function (freshCart) {
        const sig = ancestralCartTraySignature(freshCart);

        // Stale-render reconciliation: if the drawer painted an intermediate
        // cart state (rows/quantities disagree with the real cart), push an
        // in-place refresh with the fresh cart — no close/reopen. Cooldown +
        // streak cap inside ForceRefresh prevent any loop. Never force while
        // a decoration pass is mid-flight (transient mismatches are expected).
        if (
          !ancestralCartTrayPassRunning &&
          document.querySelector("#slidecarthq .items .item")
        ) {
          if (!ancestralCartTrayRowsMatch(freshCart)) {
            if (ancestralCartTrayForceRefresh(freshCart)) {
              ancestralCartTrayScheduleSettleCheck();
              return;
            }
          } else {
            ancestralCartTrayForceStreak = 0;
          }
        }
        ancestralCartTrayScheduleSettleCheck();

        if (
          sig === ancestralCartTrayLastSig &&
          ancestralCartTrayStillDecorated(freshCart)
        ) {
          // Lines unchanged and rows still decorated (attribute-only update
          // from Kite's allocation sync) — nothing visible to redo.
          applyCountCart(freshCart);
          removeLoadingCartTray();
          return;
        }
        ancestralCartTrayLastSig = sig;
        Promise.resolve(ancestralApplyWidgetRechargeCartTray(freshCart)).catch(
          function (err) {
            console.error("cart tray: widget pass failed", err);
            removeLoadingCartTray();
          }
        );
        try {
          handOptionAllProductSildeCartAR();
          applyCountCart(freshCart);
        } catch (err) {
          console.error("cart tray: decorate failed", err);
          removeLoadingCartTray();
        }
      });
  }, 300);
};
function loadingCart() {
  const sliderCartLoad = document.querySelector('#slidecarthq');
  if(!sliderCartLoad.classList.contains('active')){
    sliderCartLoad.classList.add('active');
  }
}
window.SLIDECART_OPENED = function() {
  handOptionAllProductSildeCartAR();
  if (typeof window.ancestralSlideCartSyncFromServer === "function") {
    window.ancestralSlideCartSyncFromServer("opened");
  }
}

window.SLIDECART_UPSELL_ADD = function(id) {
  loadingCart();
}

// Labor Day promo gifts auto-added by Checkout Wizard (no Kite widget).
// This preview uses Dawn's native cart-drawer, not Slide Cart HQ — so we
// re-render that drawer from /cart.js + the sections API whenever the cart
// is mutated (or while the drawer is open and the server cart has more lines).
window.ANCESTRAL_PROMO_GIFT_VARIANT_IDS = window.ANCESTRAL_PROMO_GIFT_VARIANT_IDS || {
  43096240160905: "digestive-enzymes",
  45245746937993: "tallow-balm",
};

var ancestralSlideCartSyncTimer = null;
var ancestralSlideCartSyncInFlight = false;
var ancestralDawnCartLastSig = null;
var ancestralBurstTimers = [];

function ancestralDawnDrawerLineCount() {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return 0;
  return drawer.querySelectorAll(
    "#CartDrawer-CartItems .cart-item, cart-drawer-items .cart-item, [id^='CartDrawer-Item-']"
  ).length;
}

function ancestralPaintDawnCartDrawer(sections) {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return false;

  if (sections["cart-drawer"]) {
    const html = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
    const src =
      html.querySelector("#CartDrawer") ||
      html.querySelector("cart-drawer .drawer__inner") ||
      html.querySelector(".drawer__inner");
    const dest =
      drawer.querySelector("#CartDrawer") || drawer.querySelector(".drawer__inner");
    if (src && dest) dest.innerHTML = src.innerHTML;
  }

  if (sections["cart-icon-bubble"]) {
    const html = new DOMParser().parseFromString(
      sections["cart-icon-bubble"],
      "text/html"
    );
    const dest = document.getElementById("cart-icon-bubble");
    const src = html.querySelector(".shopify-section") || html.body.firstElementChild;
    if (dest && src) dest.innerHTML = src.innerHTML;
  }

  drawer.classList.remove("is-empty");
  const inner = drawer.querySelector(".drawer__inner");
  if (inner) inner.classList.remove("is-empty");
  const itemsEl = drawer.querySelector("cart-drawer-items");
  if (itemsEl) itemsEl.classList.remove("is-empty");
  document.body.classList.remove("is-emptycart");

  const overlay = drawer.querySelector("#CartDrawer-Overlay");
  if (overlay) overlay.addEventListener("click", drawer.close.bind(drawer));
  return true;
}

window.ancestralSlideCartSyncFromServer = function (reason) {
  if (ancestralSlideCartSyncTimer) clearTimeout(ancestralSlideCartSyncTimer);
  ancestralSlideCartSyncTimer = setTimeout(function () {
    ancestralSlideCartSyncTimer = null;
    if (ancestralSlideCartSyncInFlight) return;
    ancestralSlideCartSyncInFlight = true;

    fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        const sig = ancestralCartTraySignature(cart);
        const dawnCount = ancestralDawnDrawerLineCount();
        const dawnStale =
          document.querySelector("cart-drawer") &&
          dawnCount !== (cart.items || []).length;
        const slideStale =
          document.querySelector("#slidecarthq") &&
          !ancestralCartTrayRowsMatch(cart);

        if (
          sig === ancestralDawnCartLastSig &&
          sig === ancestralCartTrayLastSig &&
          !dawnStale &&
          !slideStale
        ) {
          return;
        }
        ancestralDawnCartLastSig = sig;
        ancestralCartTrayLastSig = sig;

        if (typeof window.SLIDECART_SET_CART === "function") {
          window.SLIDECART_SET_CART(cart);
        } else if (typeof window.SLIDECART_UPDATE === "function") {
          window.SLIDECART_UPDATE(cart);
        }

        if (!document.querySelector("cart-drawer")) return null;
        return fetch("/?sections=cart-drawer,cart-icon-bubble", {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        }).then(function (res) {
          return res.json();
        }).then(function (sections) {
          ancestralPaintDawnCartDrawer(sections);
        });
      })
      .catch(function () {})
      .finally(function () {
        ancestralSlideCartSyncInFlight = false;
      });
  }, 250);
};

window.ancestralBurstCartSync = function () {
  ancestralBurstTimers.forEach(function (id) {
    clearTimeout(id);
  });
  ancestralBurstTimers = [0, 400, 900, 1600, 2800, 4500].map(function (ms) {
    return setTimeout(function () {
      window.ancestralSlideCartSyncFromServer("burst");
    }, ms);
  });
};

(function ancestralSlideCartInstallCartWatchers() {
  if (window.__ancestralSlideCartWatchers) return;
  window.__ancestralSlideCartWatchers = true;

  function isCartMutation(url) {
    return /\/cart\/(add|update|change|clear)(\.js)?([/?#]|$)/i.test(
      String(url || "")
    );
  }

  if (typeof window.fetch === "function") {
    const origFetch = window.fetch;
    window.fetch = function (input) {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      const p = origFetch.apply(this, arguments);
      if (isCartMutation(url)) {
        p.then(function (res) {
          if (res && res.ok) window.ancestralBurstCartSync();
        }).catch(function () {});
      }
      return p;
    };
  }

  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ancestralCartUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this.__ancestralCartUrl)) {
      this.addEventListener("load", function () {
        if (this.status >= 200 && this.status < 300) {
          window.ancestralBurstCartSync();
        }
      });
    }
    return origSend.apply(this, arguments);
  };

  document.addEventListener("cart:updated", function () {
    window.ancestralBurstCartSync();
  });

  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function (_e, _xhr, settings) {
      if (settings && isCartMutation(settings.url)) window.ancestralBurstCartSync();
    });
  }

  setInterval(function () {
    const dawn = document.querySelector("cart-drawer");
    const slide = document.querySelector("#slidecarthq");
    const dawnOpen = dawn && dawn.classList.contains("active");
    const slideOpen =
      slide &&
      (slide.classList.contains("open") ||
        slide.classList.contains("active") ||
        slide.classList.contains("visible"));
    if (dawnOpen || slideOpen) {
      window.ancestralSlideCartSyncFromServer("poll-open");
    }
  }, 1500);
})();